import { useState } from "react";
import axios from "axios";
import "./modal.css";

const Modal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    query: "",
  });

  const [errors, setErrors] = useState({});
  
  const validateForm = () => {
    let newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(formData.name)) {
      newErrors.name = "Only alphabets are allowed";
    } else if (formData.name.length > 50) {
      newErrors.name = "Name must not exceed 50 characters";
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (!mobileRegex.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.query.trim()) {
      newErrors.query = "Query is required";
    } else if (formData.query.length > 200) {
      newErrors.query = "Query must not exceed 200 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "name" && value.length > 50) return;
    if (name === "mobileNumber" && value.length > 10) return;
    if (name === "query" && value.length > 200) return;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await axios.post("https://dev2be.artoreal.com/rest/V1/seventh-august/request", formData);

      // Handling response properly
      const successMessage = response?.data?.message || "Form submitted successfully!";
      alert(successMessage);
      onClose();
    } catch (error) {
      // Handling API errors properly
      const errorMessage = error?.response?.data?.message || "Something went wrong! Please try again.";
      alert(errorMessage);
      console.error("Error submitting form:", error);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-box">
        <h2 className="modal-heading">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <input
            className="modal-input"
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          {errors.name && <p className="error-text">{errors.name}</p>}

          <input
            className="modal-input"
            type="text"
            name="mobileNumber"
            placeholder="Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange}
            required
          />
          {errors.mobileNumber && <p className="error-text">{errors.mobileNumber}</p>}

          <input
            className="modal-input"
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {errors.email && <p className="error-text">{errors.email}</p>}

          <textarea
            className="modal-textarea"
            name="query"
            placeholder="Type your Query Here"
            value={formData.query}
            onChange={handleChange}
            required
          ></textarea>
          {errors.query && <p className="error-text">{errors.query}</p>}

          <button className="modal-submit" type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Modal;
